<template>
  <div>
    <v-tabs v-model="activeTab"
            grow
            background-color="primary"
            dark
            center-active
            show-arrows
    >
      <v-tab v-for="tab in tabs"
             :key="tab.code"
             :href="`#${tab.code}`"
      >
        {{ tab.text }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item value="company">
        <CompanySettings/>
      </v-tab-item>
      <v-tab-item value="system">
        <SystemSettingsView/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CompanySettings from "./settings/CompanySettings/CompanySettings";
import SystemSettingsView from "./settings/SystemSettings/SystemSettingsView";

export default {
  name: "Settings",
  components: {
    CompanySettings,
    SystemSettingsView,
  },
  data() {
    return {
      tabs: [
        {
          text: 'Настройки организации',
          code: 'company'
        },
        {
          text: 'Настройки системы',
          code: 'system'
        },
      ],
      activeTab: null
    };
  },
  created() {
    if (this.tabs.length)
      this.activeTab = this.tabs[0].code;
  }
}
</script>